/** Shared shell for major blocks inside the structured Prompt card (Variables, template, callouts). */
export const STRUCTURED_PROMPT_SECTION =
  "rounded-lg border border-border bg-muted/20 p-4 space-y-3";

/** Title row inside a structured prompt section. */
export const STRUCTURED_PROMPT_SECTION_TITLE = "text-sm font-gc-med text-foreground";

/** Supporting copy under a section title. */
export const STRUCTURED_PROMPT_SECTION_DESCRIPTION = "text-xs text-muted-foreground leading-snug";
